<template>
  <BaseModal
    name="modal-leadlovers"
    size="lg"
    :title="$t('seller.products.leadlovers.text_457')"
    @shown="openModal"
    @hidden="closeModal"
  >
    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <section class="container-arquivos" v-else>
      <div class="lista-entrega lista-arquivos mt-4">
        <div>
          <h4 class="title-inter">• LeadLovers</h4>
          <div class="d-flex mb-2" data-anima="top">
            <b-col cols="12" data-anima="top">
              <BaseButton
                v-if="
                  gerenciar === false &&
                  !newConnection &&
                  selectedConection === null
                "
                @click="newConnection = true"
                variant="black"
                class=""
                >
                  {{ $t('seller.products.leadlovers.text_1935') }}
                </BaseButton>
                  <b-col v-if="newConnection"  rows="12" cols="12">
                    <b-row>
                      <b-form style="display: flex; width: 100%; flex-wrap: wrap" novalidate>
                        <b-col cols="12" md="12">
                          <b-form-group :label="$t('seller.products.leadlovers.text_459')" label-for="title">
                            <b-form-input
                              v-validate="'required'"
                              name="title"
                              id="title"
                              :placeholder="$t('seller.products.leadlovers.text_460')"
                              type="text"
                              v-model="payload.title"
                              autocomplete="off"
                            />
                            <b-form-invalid-feedback :state="!errors.has('title')">
                              {{ $t('seller.products.leadlovers.text_461') }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12">
                          <b-form-group :label="$t('seller.products.leadlovers.text_462')" label-for="token">
                            <b-form-input
                              name="token"
                              id="token"
                              placeholder=""
                              type="text"
                              v-model="payload.api_token_leadlovers"
                              autocomplete="off"
                            />
                            <b-form-invalid-feedback :state="!errors.has('token')">
                              {{ $t('seller.products.leadlovers.text_463') }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                      </b-form>
                    </b-row>
                  </b-col>
              <div class="d-flex">
                <BaseButton
                  variant="link-info"
                  class="gerencia-conexoes mt-3 mr-3"
                  @click="newConnection = false"
                  v-if="gerenciar === false && newConnection"
                >
                  {{ $t('seller.products.leadlovers.text_464') }}
                </BaseButton>
                <BaseButton
                  variant="black"
                  class="gerencia-conexoes mt-3"
                  @click="createVoxuy"
                  v-if="gerenciar === false && newConnection"
                  >{{ $t('seller.products.leadlovers.text_465') }}</BaseButton
                >
              </div>
              <iframe
                v-if="openIntFrame"
                height="0"
                width="0"
                style="display: none"
                :src="srcIframe"
              ></iframe>
            </b-col>
          </div>
          <div
            v-if="infusionsoft.length === 0 && gerenciar === false"
            data-anima="top"
          >
            <p>
              {{ $t('seller.products.leadlovers.text_466') }}
            </p>
            <p>
              {{ $t('seller.products.leadlovers.text_467') }}
            </p>
            <br />
            <p>{{ $t('seller.products.leadlovers.text_468') }}</p>
          </div>
          <b-col
            cols="12"
            data-anima="top"
            v-if="infusionsoft.length !== 0 && !newConnection"
          >
            <ul class="mt-3" v-if="selectedConection === null">
              <li
                v-for="(item, index) in infusionsoft"
                :key="item.title + item.id"
                data-anima="bottom"
              >
                <div @click="selectItem(item.id)">
                  <img
                    src="@/assets/img/icons/checkItem.svg"
                    class="icon-file"
                  />
                  <div class="info-list">
                    <span>
                      #{{ item.id }} - {{ item.title }}
                      <p data-anima="bottom" class="ativo">
                        {{ $t('seller.products.leadlovers.text_469') }} {{ moment(item.created_at).locale('pt-br').format('DD/MM/YYYY [às] HH:mm') }}
                      </p>
                    </span>
                  </div>
                </div>
                <div class="acoes-webhook">
                  <img
                    src="@/assets/img/icons/lixeira.svg"
                    class="icon-lixeira"
                    :id="'btn-remover-' + item.id"
                    @click="removeConection(item.id)"
                  />
                  <b-tooltip
                    :target="'btn-remover-' + item.id"
                    :title="$t('seller.products.leadlovers.text_470')"
                    placement="top"
                  />
                </div>
              </li>
            </ul>

            <ul v-else>
              <li data-anima="bottom">
                <div>
                  <img
                    src="@/assets/img/icons/checkItem.svg"
                    class="icon-file"
                  />
                  <div class="info-list">
                    <span>
                      #{{ selectedConection }} -
                      {{ filterItem(selectedConection)[0].title }}
                    </span>
                  </div>
                </div>
              </li>
            </ul>
          </b-col>
          <b-col
            cols="12"
            class="mt-4"
            data-anima="top"
            v-if="selectedConection"
          >
            <h6 class="titulo-acao" v-if="selectedTypeAction !== null">
              {{ $t('seller.products.leadlovers.text_471') }}
            </h6>
            <b-form novalidate>
            <h4 class="title-inter">{{ $t('seller.products.leadlovers.text_471') }}</h4>
            <div class="grid-events">
              <b-form-group :label="$t('seller.products.leadlovers.text_1936')" label-for="check">
                <b-form-checkbox
                  size="md"
                  switch
                  class="check-box mb-2"
                  v-for="(op, index) in events.options_sales"
                  :name="`check-${index}`"
                  :id="`check-${index}`"
                  v-model="selectEvent[index]"
                  :key="op.value"
                  @change="triggerChanged(op.value)"
                >
                  <p class="info-checkbox">{{ op.text }}</p>
                  <div
                    v-show="op.value == 'saleRefused' && selectEvent[1]"
                    data-anima="top"
                    class="mt-3 mb-3"
                  >
                    <b-form-checkbox
                      size="md"
                      switch
                      v-for="(sub, index) in events.options_salesRefused"
                      class="check-box mb-2"
                      :name="`check-refunsed-${index}`"
                      :id="`check-refunsed-${index}`"
                      :key="sub.value"
                      v-model="selectEventRefunsed[index]"
                      @change="subTriggerChanged(sub.value, 'saleRefused')"
                    >
                      <p class="info-checkbox">{{ sub.text }}</p>
                    </b-form-checkbox>
                  </div>
                  <div
                    v-show="op.value == 'saleWaitingPayment' && selectEvent[5]"
                    data-anima="top"
                    class="mt-3 mb-3"
                  >
                    <b-form-checkbox
                      size="md"
                      switch
                      v-for="(sub, index) in events.options_salesWaiting"
                      class="check-box mb-2"
                      :name="`check-waiting-${index}`"
                      :id="`check-waiting-${index}`"
                      :key="sub.value"
                      v-model="selectEventWaiting[index]"
                      @change="
                        subTriggerChanged(sub.value, 'saleWaitingPayment')
                      "
                    >
                      <p class="info-checkbox">{{ sub.text }}</p>
                    </b-form-checkbox>
                  </div>
                </b-form-checkbox>
              </b-form-group>

              <b-form-group :label="$t('seller.products.leadlovers.text_1937')" label-for="check">
                <b-form-checkbox
                  size="md"
                  switch
                  class="check-box mb-2"
                  name="check"
                  v-for="op in events.options_sub"
                  :key="op.value"
                  @change="triggerChanged(op.value)"
                >
                  <p class="info-checkbox">{{ op.text }}</p>
                </b-form-checkbox>
              </b-form-group>

              <b-form-group label="Checkout" label-for="check">
                <b-form-checkbox
                  size="md"
                  switch
                  class="check-box mb-2"
                  name="check"
                  v-for="op in events.options_checkout"
                  :key="op.value"
                  @change="triggerChanged(op.value)"
                >
                  <p class="info-checkbox">{{ op.text }}</p>
                </b-form-checkbox>
              </b-form-group>
            </div>
          </b-form>
          </b-col>
          <span>
            <b-col>
              <b-row v-if="infusionsoft.length !== 0 &&
                selectedConection !== null">
                <b-col cols="12">
                  <b-form-group
                    :label="$t('seller.products.leadlovers.text_472')"
                    label-for="form_list_active_machine"
                  >
                    <multiselect
                      v-model="machine"
                      :options="machines"
                      :value="machine"
                      :multiple="false"
                      :close-on-select="true"
                      :clearOnSelect="true"
                      :preserve-search="true"
                      :placeholder="$t('seller.products.leadlovers.text_472')"
                      label="MachineName"
                      @input="getLeadLoversSequence"
                      track-by="MachineName"
                      selectLabel=""
                      deselectLabel=""
                      selectedLabel="✔️"
                      id="multi_select_list_active_machine"
                      name="list_active_machine"
                      :custom-label="customLabel"
                    >
                      <template slot="afterList">
                        <div v-observe-visibility="reachedEndOfList" />
                      </template>
                    </multiselect>
                    <b-form-invalid-feedback :state="!errors.has('list_active_machine')">
                      {{ $t('seller.products.leadlovers.text_473') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- sequencia -->
              <b-row v-if="infusionsoft.length !== 0 &&
                selectedConection !== null && machine !== ''">
                <b-col cols="12">
                  <b-form-group
                    :label="$t('seller.products.leadlovers.text_474')"
                    label-for="form_list_active_sequence"
                  >
                    <multiselect
                      v-model="sequence"
                      :options="sequences"
                      :value="sequence"
                      :multiple="false"
                      :close-on-select="true"
                      :clearOnSelect="true"
                      :preserve-search="true"
                      :placeholder="$t('seller.products.leadlovers.text_474')"
                      label="SequenceName"
                      @input="getLeadLoversLevels"
                      track-by="SequenceName"
                      selectLabel=""
                      deselectLabel=""
                      selectedLabel="✔️"
                      id="multi_select_list_active_sequence"
                      name="list_active_sequence"
                      :custom-label="({ SequenceName }) => SequenceName"
                    >
                      <template slot="afterList">
                        <div v-observe-visibility="reachedEndOfList" />
                      </template>
                    </multiselect>
                    <b-form-invalid-feedback :state="!errors.has('list_active_sequence')">
                      {{ $t('seller.products.leadlovers.text_475') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="infusionsoft.length !== 0 &&
                selectedConection !== null && sequence !== ''">
                <b-col cols="12">
                  <b-form-group
                    :label="$t('seller.products.leadlovers.text_476')"
                    label-for="form_list_active_cb"
                  >
                    <multiselect
                      v-model="callback_type"
                      :options="callback_types"
                      :value="callback_type"
                      :multiple="false"
                      :close-on-select="true"
                      :clearOnSelect="true"
                      :preserve-search="true"
                      :placeholder="$t('seller.products.leadlovers.text_477')"
                      selectLabel=""
                      label="callback"
                      track-by="callback"
                      deselectLabel=""
                      selectedLabel="✔️"
                      id="multi_select_list_active_cb"
                      name="list_active_cb"
                      :custom-label="({ descricao }) => descricao"
                    >
                      <template slot="afterList">
                        <div v-observe-visibility="reachedEndOfList" />
                      </template>
                    </multiselect>
                    <b-form-invalid-feedback :state="!errors.has('list_active_cb')">
                      {{ $t('seller.products.leadlovers.text_478') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- cb_to -->
              <b-row v-if="infusionsoft.length !== 0 &&
                selectedConection !== null && callback_type && callback_type.callback === 'moveLeadlovers'">
                <b-col cols="12">
                  <b-form-group
                    :label="$t('seller.products.leadlovers.text_479')"
                    label-for="form_list_active_machine_to"
                  >
                    <multiselect
                      v-model="machine_to"
                      :options="machines"
                      :value="machine_to"
                      :multiple="false"
                      :close-on-select="true"
                      :clearOnSelect="true"
                      :preserve-search="true"
                      :placeholder="$t('seller.products.leadlovers.text_479')"
                      label="MachineName"
                      @input="getLeadLoversSequenceTo"
                      track-by="MachineName"
                      selectLabel=""
                      deselectLabel=""
                      selectedLabel="✔️"
                      id="multi_select_list_active_machine_to"
                      name="list_active_machine_to"
                      :custom-label="customLabel"
                    >
                      <template slot="afterList">
                        <div v-observe-visibility="reachedEndOfList" />
                      </template>
                    </multiselect>
                    <b-form-invalid-feedback :state="!errors.has('list_active_machine_to')">
                      {{ $t('seller.products.leadlovers.text_480') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- sequencia -->
              <b-row v-if="infusionsoft.length !== 0 &&
                selectedConection !== null && machine_to !== ''">
                <b-col cols="12">
                  <b-form-group
                    :label="$t('seller.products.leadlovers.text_481')"
                    label-for="form_list_active_sequence_to"
                  >
                    <multiselect
                      v-model="sequence_to"
                      :options="sequences_to"
                      :value="sequence_to"
                      :multiple="false"
                      :close-on-select="true"
                      :clearOnSelect="true"
                      :preserve-search="true"
                      :placeholder="$t('seller.products.leadlovers.text_481')"
                      label="SequenceName"
                      @input="getLeadLoversLevelsTo"
                      track-by="SequenceName"
                      selectLabel=""
                      deselectLabel=""
                      selectedLabel="✔️"
                      id="multi_select_list_active_sequence_to"
                      name="list_active_sequence_to"
                      :custom-label="({ SequenceName }) => SequenceName"
                    >
                      <template slot="afterList">
                        <div v-observe-visibility="reachedEndOfList" />
                      </template>
                    </multiselect>
                    <b-form-invalid-feedback :state="!errors.has('list_active_sequence_to')">
                      {{ $t('seller.products.leadlovers.text_482') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- level, é o único que não precisa setar quando se move -->
              <b-row v-if="infusionsoft.length !== 0 &&
                selectedConection !== null && callback_type !== ''">
                <b-col cols="12">
                  <b-form-group
                    :label="$t('seller.products.leadlovers.text_483')"
                    label-for="form_list_active_level"
                  >
                    <multiselect
                      v-model="level"
                      :options="levels"
                      :value="level"
                      :multiple="false"
                      :close-on-select="true"
                      :clearOnSelect="true"
                      :preserve-search="true"
                      :placeholder="$t('seller.products.leadlovers.text_483')"
                      label="Subject"
                      track-by="Subject"
                      selectLabel=""
                      deselectLabel=""
                      selectedLabel="✔️"
                      id="multi_select_list_active_level"
                      name="list_active_level"
                      :custom-label="({ Subject }) => Subject"
                    >
                      <template slot="afterList">
                        <div v-observe-visibility="reachedEndOfList" />
                      </template>
                    </multiselect>
                    <b-form-invalid-feedback :state="!errors.has('list_active_level')">
                      {{ $t('seller.products.leadlovers.text_484') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col
              cols="12"
              v-if="
                infusionsoft.length !== 0 &&
                selectedConection !== null &&
                makePlanilha === false
              "
            >
              <!-- <BaseButton
                variant="danger"
                class="gerencia-conexoes mt-3 mr-3"
                v-if="lista"
                @click="deletePlanilha"
                >Deletar Planilha</BaseButton
              > -->
              <!-- <BaseButton
                variant="black"
                class="gerencia-conexoes mt-3"
                @click="makePlanilha = true"
                >Nova Planilha</BaseButton
              > -->
            </b-col>
          </span>
        </div>
        <div class="d-flex justify-content-center" v-if="loading">
          <b-spinner label="Loading..."></b-spinner>
        </div>
      </div>
    </section>

    <!-- Modal conexoes -->
    <Conexoes @close="fetchConnection" />

    <template v-slot:footer="{ cancel }">
      <BaseButton
        :disabled="loading"
        variant="link-info"
        class="mr-4"
        @click="cancel"
      >
        {{ $t('seller.products.leadlovers.text_485') }}
      </BaseButton>
      <BaseButton
        v-if="
          gerenciar === false &&
          infusionsoft.length !== 0 &&
          selectedConection !== null
        "
        variant="black"
        :disabled="loading"
        @click="createCallback"
      >
        {{ $t('seller.products.leadlovers.text_486') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script>
import Conexoes from "../../MyAccount/modals/Conexoes";
import Cookies from "js-cookie";
// services:
import ConnectionService from "@/services/resources/ConnectionService";
const serviceConnection = ConnectionService.build();

import GoogleSheetsService from "@/services/resources/GoogleSheetsService";
const serviceGoogleSheets = GoogleSheetsService.build();

import InfusionsoftService from "@/services/resources/InfusionsoftService";
const  infusionsoftService= InfusionsoftService.build();

import ProductService from "@/services/resources/ProductService";
const  productionService = ProductService.build();

import LeadLoversService from "@/services/resources/LeadLoversService";
const  leadloversService = LeadLoversService.build();

import Multiselect from "vue-multiselect";
import CallbackService from "@/services/resources/CallbackService";
const serviceCallback = CallbackService.build();
import { convertTrigger } from "@/helpers.js";
import moment from 'moment';

export default {
  data() {
    return {
      metaIsEdited: false,
      editMeta: false,
      editMetaItem: {},
      levels: [],
      levels_to: [],
      level: '',
      level_to: '',
      machines: [],
      machine_to: '',
      machine: '',
      sequences: [],
      sequences_to: [],
      callback_type: '',
      callback_types: [
        {
          descricao: 'Inserir',
          callback: 'insertLeadlovers'
        },
        {
          descricao: 'Mover',
          callback: 'moveLeadlovers'
        },
        {
          descricao: 'Remover',
          callback: 'removeLeadlovers'
        },
      ],
      sequence: '',
      sequence_to: '',
      moment: moment,
      payload: {
        name: null,
        plan_id: null
      },
      selectedTypeAction: null,
      makePlanilha: false,
      newPlanilha: "",
      nameConnection: "",
      newConnection: false,
      optionsConection: [{ id: null, name: this.$t('seller.products.leadlovers.text_487') }],
      selectedConection: null,
      openIntFrame: false,
      srcIframe: "",
      loading: false,
      submit: false,
      infusionsoft: [],
      connection_name: null,
      connection_api_key: null,
      connection_base_url: null,
      lista_options: [],
      lista_options_prev: null,
      lista_options_next: null,
      select_callback: "leadlovers",
      trigger: [],
      metas: [],
      callback: [],
      lista: null,
      gerenciar: false,
      multiselect: true,
      selectEvent: [],
      selectEventRefunsed: [],
      selectEventWaiting: [],
      events: {
        trigger: [],
        sub_trigger: [],
        sub_trigger2: [],
        url: "",
        callback: "voxuy",
        options_sales: [
          {
            value: "salePaid",
            text: "Venda Paga",
          },
          {
            value: "saleRefused",
            text: "Venda Recusada",
          },
          {
            value: "saleRefunded",
            text: "Venda Reembolsada",
          },
          {
            value: "saleChargedback",
            text: "Chargeback realizado",
          },
          {
            value: "saleUnpaid",
            text: "Venda não paga",
          },
          {
            value: "saleWaitingPayment",
            text: "Venda aguardando pagamento",
          },
        ],
        options_salesWaiting: [
          {
            value: "TODOS",
            text: "Todos",
          },
          {
            value: "BOLETO",
            text: "Boleto",
          },
          {
            value: "PIX",
            text: "PIX",
          },
        ],
        options_salesRefused: [
          {
            value: "TODOS",
            text: "Todos",
          },
          {
            value: "INVALID_CREDIT_CARD",
            text: "Cartão inválido/bloqueado",
          },
          {
            value: "INSUFFICIENT_FUNDS",
            text: "Cartão sem limite",
          },
          {
            value: "INVALID_PAYMENT_TYPE",
            text: "Método de pagamento inválido",
          },

          {
            value: "INVALID_DATA",
            text: "Dados do cartão inválidos",
          },
          {
            value: "INVALID_CLIENT_DATA",
            text: "Dados do cliente inválidos",
          },
          {
            value: "INVALID_CVV",
            text: "CVV do cartão inválido",
          },
          {
            value: "BANK",
            text: "Problema: Banco emissor do cartão",
          },
          {
            value: "CREDIT_CARD_OPERATOR",
            text: "Problema: Operadora do cartão",
          },

          {
            value: "INVALID_INSTALLMENTS",
            text: "Qtd parcelas não autorizada",
          },
          {
            value: "CURRENCY_NOT_SUPPORTED",
            text: "Moeda não autorizada",
          },
          {
            value: "SUSPECTED_FRAUD",
            text: "Suspeita de Fraude",
          },
          {
            value: "GENERIC",
            text: "Erro ao processar a compra",
          },
        ],
        options_sub: [
          {
            value: "contractUnpaid",
            text: "Assinatura não paga",
          },
          {
            value: "contractPaid",
            text: "Assinatura paga",
          },
          {
            value: "contractTrialing",
            text: "Assinatura em Trial",
          },
          {
            value: "contractPendingPayment",
            text: "Assinatura aguardando pagamento",
          },
          {
            value: "contractEnded",
            text: "Assinatura Finalizada",
          },
          {
            value: "contractCanceled",
            text: "Assinatura Cancelada",
          },
        ],
        options_checkout: [
          {
            value: "checkoutAbandoned",
            text: "Checkout Abandonado",
          },
        ],
      },
    };
  },
  props: {
    id_product: {
      type: Number,
    },
  },
  components: {
    Conexoes,
    Multiselect,
  },
  methods: {
    changeEditMeta(i) {
      this.editMeta = true;
      this.metaIsEdited = true;
      this.editMetaItem = i
      let item = i
      item.value = JSON.parse(i.value)
      this.payload = i.value
    },
    deletePlanilha() {
      console.log(this.lista);
      this.loading = true;

      let data = {
        connection_id: this.selectedConection,
        id_file: this.lista.id,
      };

      serviceGoogleSheets
        .destroyAll(data)
        .then((response) => {
          this.loading = false;
          this.lista = null;
          this.fetchLists();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    novaPlanilha() {
      // this.loading = true;
      let data = {
        id: `?connection_id=${this.selectedConection}`,
        title: this.newPlanilha,
        type: this.selectedTypeAction,
      };

      infusionsoftService
        .createId(data)
        .then((response) => {
          console.log("get list sheets", response);
          this.lista_options = [];
          this.newPlanilha = "";
          this.lista_options_next = null;
          this.lista_options_prev = null;
          this.makePlanilha = false;
          this.fetchLists("first");
          // this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.makePlanilha = false;
        })
        .finally(() => {
          // this.loading = false;
        });
    },
    filterItem(id, type) {
      let myArray = this.optionsConection;
      return myArray.filter((x) => x.id === id);
    },
    selectItem(id) {
      this.selectedConection = id;
      this.lista_options = []
      this.getLeadLoversMachines();
      // this.getProductMeta();
      // this.fetchLists('first');
    },
    removeConection(id) {
      this.loading = true;
      serviceConnection
        .destroy(id)
        .then((response) => {
          this.loading = false;
          this.fetchConnection();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openWindowInfusionsoft() {

      const cleanWhiteSpaces = (text) => {
        let result = '';
        text.split('').map(letter => letter !== ' ' ? result=result+letter : result=result+'-');
        return result;
      }

      const host = `${process.env.VUE_ADM_PAGE}${this.$route.fullPath}/${cleanWhiteSpaces(this.nameConnection)}`
      // const fake = `http://localhost:8089${this.$route.fullPath}/${cleanWhiteSpaces(this.nameConnection)}`
      
      location.replace(`
        https://accounts.infusionsoft.com/app/oauth/authorize?response_type=code&redirect_uri=${host}&client_id=${process.env.VUE_KEAP_CLIENT_ID}
      `)

      setTimeout(() => {
        // this.openIntFrame = true;
        this.newConnection = false;
        this.intervalConnections();
      }, 3000);
    },
    intervalConnections() {
      var that = this;
      this.intervalid1 = setInterval(function () {
        that.fetchConnection();
      }, 5000);
    },
    triggerCallbackChanged(v) {
      if (v.value === "leadlovers") {
        this.options_callback[1].type = false;
        this.options_callback[0].type = true;
      } else {
        this.options_callback[0].type = false;
        this.options_callback[1].type = true;
      }

      if (this.options_callback[0].type === true) {
        this.select_callback = v.value;
      }

      if (this.options_callback[1].type === true) {
        this.select_callback = v.value;
      }

    },
    resetInputs() {
      this.infusionsoft = [];
      this.sub_trigger2 = [];
      this.connection_name = null;
      this.connection_api_key = null;
      this.connection_base_url = null;
      this.lista_options = [];
      this.tag_options = [];
      this.tag = null;
      this.metas = []
      this.editMeta = false
      this.editMetaItem = {}
      this.openIntFrame = false;
      this.selectEvent = [];
      this.selectEventRefunsed = [];
      this.selectEventWaiting = [];
      // this.options_callback[0].type = true;
      // this.options_callback[1].type = false;
      this.select_callback = "leadlovers";
      this.trigger = [];
      this.lista = null;
      this.gerenciar = false;
    },
    createVoxuy() {
      this.loading = true;
      serviceConnection
        .create({ ...this.payload, type: 'leadlovers' })
        .then(() => {
          this.submit = false;
          this.loading = false;
          this.newConnection = false;
          this.payload = {}
          this.fetchConnection();
          this.$bvToast.toast(this.$t('seller.products.leadlovers.text_488'), {
            title: "LeadLovers",
            variant: "success",
            autoHideDelay: 5000,
            appendToast: true,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // getProductMeta() {
    //   this.loading_meta = true;
    //   let data = {
    //     id: `${this.id_product}/meta`,
    //   };

    //   this.metas = [];

    //   productionService
    //     .read(data)
    //     .then((response) => {
    //       if (response.length) {
    //         this.metas = response.reverse();
    //       } else {
    //         this.metas = response;
    //       }
    //     })
    //     .finally(() => {
    //       this.loading_meta = false;
    //     });
    // },
    getLeadLoversMachines() {
      leadloversService
        .search({ url: '/machine' })
        .then((response) => {
          if (response.Items.length) {
            this.machines = response.Items.reverse();
          } else {
            this.machines = response.Items;
          }
        })
    },
    getLeadLoversLevels() {
      leadloversService
        .search({ url: `/level?machine=${this.machine.MachineCode}&sequence=${this.sequence.SequenceCode}` })
        .then((response) => {
          if (response.Items.length) {
            this.levels = response.Items.reverse();
          } else {
            this.levels = response.Items;
          }
        })
    },
    getLeadLoversSequence() {
      leadloversService
        .search({ url: `/sequence?machine=${this.machine.MachineCode}` })
        .then((response) => {
          if (response.Items.length) {
            this.sequences = response.Items.reverse();
          } else {
            this.sequences = response.Items;
          }
        })
    },
    getLeadLoversLevelsTo() {
      leadloversService
        .search({ url: `/level?machine=${this.machine_to.MachineCode}&sequence=${this.sequence_to.SequenceCode}` })
        .then((response) => {
          if (response.Items.length) {
            this.levels = response.Items.reverse();
          } else {
            this.levels = response.Items;
          }
        })
    },
    getLeadLoversSequenceTo() {
      leadloversService
        .search({ url: `/sequence?machine=${this.machine_to.MachineCode}` })
        .then((response) => {
          if (response.Items.length) {
            this.sequences_to = response.Items.reverse();
          } else {
            this.sequences_to = response.Items;
          }
        })
    },
    createProductMeta() {
      this.loading = true;
      let data = this.payload;
      if (!this.metaIsEdited && this.payload.name) {
        productionService
          .create({
          key: 'product_in_leadlovers',
          value: JSON.stringify({
            name: this.payload.name,
            plan_id: this.payload.plan_id
          })}, `${this.id_product}/meta`)
          .then(() => {
            this.$bvToast.toast(this.$t('seller.products.leadlovers.text_489'), {
              title: "Meta",
              variant: "success",
              autoHideDelay: 5000,
              appendToast: true,
            });
            this.editMeta = false;
            this.editMetaItem = {}
          })
          .finally(() => {
            this.loading_meta = false;
            this.editMeta = false;
            this.editMetaItem = {}
            this.createCallback(true);
          });
      } else if (this.metaIsEdited) {
        productionService
          .update({ ...this.editMetaItem, value: JSON.stringify(data) }, `${this.id_product}/meta/${this.editMetaItem.id}`)
          .then(() => {
            this.$bvToast.toast(this.$t('seller.products.leadlovers.text_490'), {
              title: "Meta",
              variant: "success",
              autoHideDelay: 5000,
              appendToast: true,
            });
            this.editMeta = false;
            this.editMetaItem = {}
          })
          .finally(() => {
            this.loading_meta = false;
            this.editMeta = false;
            this.editMetaItem = {}
            this.createCallback(true);
          });
      } else {
        this.createCallback(true);
      }
    },
    createCallback() {
        return new Promise((resolve) => {
          this.$validator.validateAll().then((result) => {
            if (result) {
              this.submit = true;
              this.loading = true;
              let data = {
                product_id: this.id_product,
                trigger: this.connection_api_key,
                type: "leadlovers",
                callback: this.callback_type.callback,
                connection_id: this.selectedConection,
              };

              if (this.callback_type.callback === 'moveLeadlovers') {
                data = {
                  ...data,
                   machine_from: this.machine.MachineCode,
                   machine_to: this.machine_to.MachineCode,
                   sequence_from: this.sequence.SequenceCode,
                   sequence_to: this.sequence_to.SequenceCode,
                   level: this.level.Sequence,
                }
              } else {
                data = {
                  ...data,
                  machine: this.machine.MachineCode,
                  sequence: this.sequence.SequenceCode,
                  level: this.level.Sequence,
                }
              }

              if (this.trigger.length) {
                this.trigger.forEach(async (event) => {
                  data.trigger = "";
                  data.trigger = event;
                  if (event === 'saleRefused') {
                    let sub_trigger_check = false;
                    
                    this.selectEventRefunsed.map(async (item, index) => {
                      if (item && !this.selectEventRefunsed[0]) {
                        sub_trigger_check = true;
                        await this.postCallback({ ...data, sub_trigger: this.events.options_salesRefused[index].value  }, this.events.options_salesRefused[index].text);
                      }
                    })
                    if (!sub_trigger_check) {
                      await this.postCallback({ ...data, trigger: event }, event);
                    }
                  } else if(event === 'saleWaitingPayment') {
                    let sub_trigger_check = false;
                    
                    this.selectEventWaiting.map(async (item, index) => {
                      if (item && !this.selectEventWaiting[0]) {
                        sub_trigger_check = true;
                        await this.postCallback({ ...data, sub_trigger: this.events.options_salesWaiting[index].value  }, this.events.options_salesWaiting[index].text);
                      }
                    })

                    if (!sub_trigger_check) {
                      await this.postCallback({ ...data, trigger: event }, event);
                    }
                  } else {
                    await this.postCallback(data, event);
                  }
                  resolve(true);
                });
              } else {
                this.loading = false;
                this.$bvToast.toast(this.$t('seller.products.leadlovers.text_1938'), {
                  title: "LeadLovers",
                  variant: "danger",
                  autoHideDelay: 5000,
                  appendToast: true,
                });
                resolve(false);
              }
            } else {
              resolve(false);
            }
          });
        });
    },
    async postCallback(data, event) {
      serviceCallback
        .create(data)
        .then(() => {
          this.$bvToast.toast(
            `[${convertTrigger(event)}] ${this.$t('seller.products.leadlovers.text_1939')}`,
            {
              title: "LeadLovers",
              variant: "success",
              autoHideDelay: 5000,
              appendToast: true,
            }
          );
          this.$bvModal.hide("modal-leadlovers");
          this.resetInputs();
          setTimeout(() => {
            this.$emit("close");
          }, 500);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.submit = false;
          this.loading = false;
        });
    },
    // checkbox dos eventos
    triggerChanged(v) {
      if (this.trigger.includes(v)) {
        this.trigger.splice(this.trigger.indexOf(v), 1);
      } else {
        this.trigger.push(v);
      }
    },
    subTriggerChanged(v, type) {
      if (type === "saleRefused") {
        const include = this.events.sub_trigger.includes(v);

        if (v == "TODOS") {
          if (!include) {
            this.selectEventRefunsed = [];
            this.events.options_salesRefused.forEach((_, index) => {
              if (index > 0) {
                this.init_click = true;
                if (!this.selectEventRefunsed[index]) {
                  document.querySelector(`#check-refunsed-${index}`).click();
                }
              }
            });
          } else {
            this.events.options_salesRefused.forEach((_, index) => {
              if (index > 0) {
                if (this.selectEventRefunsed[index]) {
                  document.querySelector(`#check-refunsed-${index}`).click();
                }
              }
            });
          }
        }

        if (include) {
          this.events.sub_trigger.splice(this.events.sub_trigger.indexOf(v), 1);
        } else {
          this.events.sub_trigger.push(v);
        }
      }else{

        const include = this.events.sub_trigger2.includes(v);
  
        if (v == "TODOS") {
          if (!include) {
            this.selectEventWaiting = [];
            this.events.options_salesWaiting.forEach((_, index) => {
              if (index > 0) {
                this.init_click = true;
                if (!this.selectEventWaiting[index]) {
                  document.querySelector(`#check-waiting-${index}`).click();
                }
              }
            });
          } else {
            this.events.options_salesWaiting.forEach((_, index) => {
              if (index > 0) {
                if (this.selectEventWaiting[index]) {
                  document.querySelector(`#check-waiting-${index}`).click();
                }
              }
            });
          }
        }
  
        if (include) {
          this.events.sub_trigger2.splice(this.events.sub_trigger2.indexOf(v), 1);
        } else {
          this.events.sub_trigger2.push(v);
        }
      }
    },
    customLabelTags({ tag }) {
      return `${tag}`;
    },
    customLabel({ MachineName }) {
      return `${MachineName}`;
    },
    reachedEndOfList(reached) {
      // if (reached) {
      //   this.fetchLists(this.lista_options_next);
      // }
    },
    fetchLists(page) {
      let data = {
        url: '/tags',
        connection_id: this.selectedConection,
        type: "infusionsoft",
        limit: 6
      };

      if (page && page !== "first") {
        data.page = page;
      }

      infusionsoftService
        .search(data)
        .then((response) => {
          if (page && page !== "first") {
            this.lista_options.push(response.tags);
          } else {
            this.lista_options = response.tags;
          }
          // if (page === "first") {
          //   this.lista = response.tags;
          // }

          this.lista_options_next = response.nextPageToken;
          this.lista_options_prev = response.prevPageToken;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchConnection() {
      this.optionsConection = [];
      serviceConnection
        .search({ connection_id: this.selectedConection  })
        .then((response) => {
          response.forEach((element) => {
            if(element.type === 'leadlovers') {
              this.optionsConection.push({
                id: element.id,
                title: element.title,
                created_at: element.created_at
              });
            }
          });
          this.infusionsoft = this.optionsConection;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // abrindo modal e setando valores
    openModal() {
      this.loading = true;
      // puxando as conexões do voxuy
      this.fetchConnection();
    },
    closeModal() {
      clearInterval(this.intervalid1);
      this.selectedConection = null;
      this.resetInputs();
      this.optionsConection = [{ id: null, name: this.$t('seller.products.leadlovers.text_487') }];
    },
  },
};
</script>

<style scoped>
@import url(https://fonts.googleapis.com/css?family=Roboto:500);
.infusion-btn {
  width: 200px;
  height: 42px;
  cursor: pointer;
  background-color: #148d24;
  border-radius: 2px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
}
.infusion-btn .google-icon-wrapper {
  position: absolute;
  margin-top: 1px;
  margin-left: 0px;
  width: 40px;
  height: 40px;
  border-radius: 2px;
  background-color: #fff;
}
.infusion-btn .google-icon {
  position: absolute;
  margin-top: 11px;
  margin-left: 11px;
  width: 18px;
  height: 18px;
}
.infusion-btn .btn-text {
  float: right;
  margin: 11px 11px 0 0;
  color: #fff !important;
  font-size: 14px;
  letter-spacing: 0.2px;
  font-family: "Roboto";
}
.infusion-btn .btn-text b {
  color: #fff !important;
}
.infusion-btn:hover {
  box-shadow: 0 0 6px #4285f4;
}
.infusion-btn:active {
  background: #1669F2;
}

p {
  margin: 0;
  font-size: 14px;
  font-weight: normal;
  color: #81858e;
  line-height: 1.5;
}
.title-inter {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 30px;
  color: #2133d2;
}
.form-group + .form-group {
  margin-top: 15px;
}
.gerencia-conexoes {
  padding: 0 25px !important;
  height: 40px !important;
  font-size: 12px;
}

.codigo-verifica p {
  font-size: 14px;
  font-weight: normal;
  color: #81858e;
  line-height: 1.5;
  margin-bottom: 20px;
}
.sem-codigo {
  font-size: 14px;
  color: #333;
}
.sem-codigo:hover {
  font-weight: normal;
}
.grid-events {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 20px 0 10px;
}
.titulo-acao {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 10px;
}

.check-box .info-checkbox {
  font-size: 13px;
  font-weight: 500;
  margin-left: 5px;
  cursor: pointer;
  max-width: 250px;
  margin-top: 15px !important;
}
.top {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.top a {
  font-size: 14px;
  color: #81858e;
}
.lista-entrega h5 {
  color: #2133d2;
  font-weight: 600;
  font-size: 14px;
}
.lista-entrega ul,
.opcoes-entrega {
  display: flex;
  flex-direction: column;
}
.lista-entrega ul li,
.opcoes-entrega li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 17px 30px;
  height: 70px;
  border-radius: 5px;
  background: rgba(247, 247, 247, 0.5);
  font-size: 14px;
  cursor: pointer;
  transition: 0.3s;
}
@media screen and (max-width: 667px) {
  .lista-entrega ul li,
  .opcoes-entrega li {
    display: block;
    height: 100px;
  }
  .acoes-webhook {
    margin-left: 30px;
    margin-top: 7px;
  }
}
.lista-arquivos ul li {
  padding: 13px 20px;
  font-size: 13px;
}
.opcoes-entrega li {
  padding: 20px 30px;
  height: 80px;
}
.lista-entrega ul li div {
  display: flex;
  align-items: center;
  font-size: 15px;
}
.opcoes-entrega li .grid-content {
  display: grid;
  grid-template-columns: 120px 1fr;
  align-items: center;
}
.lista-entrega ul li div img.icon-file {
  width: 18px;
  margin-right: 30px;
}
.lista-entrega ul li div img + img {
  margin-left: 20px;
}
.opcoes-entrega li div img {
  width: 20px;
  margin-right: 30px;
  filter: invert(50%);
}
.item-upload {
  position: relative;
  padding: 40px;
  border: 2px dashed #ededf0;
  border-radius: 5px;
  text-align: center;
}
.item-upload:hover {
  background: #f7f7f7;
}
.item-upload h5 {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 5px;
}
.item-upload p,
.info-lista {
  font-size: 13px;
  font-weight: normal;
  color: #81858e;
  line-height: 1.5;
}
#arquivo-entrega {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100% !important;
  height: 80px;
  cursor: pointer;
  opacity: 0;
}
.opcoes-entrega li .infos h5,
.grid-content h5 {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 5px;
}
.grid-content h5 {
  margin: 0;
}
.opcoes-entrega li .infos p {
  font-size: 13px;
  font-weight: normal;
  color: #81858e;
  line-height: 1.5;
}
.opcoes-entrega li div img.logo-entrega {
  width: 60px;
}
.lista-entrega ul {
  max-height: 300px;
  overflow: auto;
}
.lista-arquivos ul {
  max-height: initial;
  overflow: initial;
}

.lista-entrega ul li .icon-editar {
  margin-right: 15px !important;
}
.lista-entrega ul li:hover,
.opcoes-entrega li:hover {
  font-weight: 600;
  background: #f7f7f7;
}
@media screen and (max-width: 667px) {
  .lista-entrega ul li:hover,
  .opcoes-entrega li:hover {
    font-weight: 500;
    background: #f7f7f7;
  }
}

.lista-entrega ul li + li,
.opcoes-entrega li + li {
  margin-top: 10px;
}

/* edição web */
.info-list {
  position: relative;
}
.info-list span {
  font-size: 14px;
}
.info-list p.ativo {
  text-transform: initial;
  font-size: 12px;
  margin-top: 3px;
  color: #81858e;
  display: block;
}
.info-list p {
  display: none;
}

.input-edit-webhook {
  height: 20px !important;
  width: 400px;
  padding: 5px 0 15px 0 !important;
  font-size: 12px !important;
  margin-bottom: -2px !important;
  margin-top: 10px !important;
  background: transparent;
  border: none !important;
  border-bottom: 1px solid #81858e !important;
  border-radius: 0 !important;
  display: none;
}
@media screen and (max-width: 667px) {
  .input-edit-webhook {
    width: 250px;
  }
}
.input-edit-webhook.ativo {
  display: block;
}
.btn-edit-web {
  display: none;
}
.btn-edit-web.ativo {
  display: block;
}

/* 
 */
.lista-entrega ul li .icon-lixeira,
.lista-entrega ul li .icon-editar {
  width: 14px;
  filter: invert(50%);
  /* padding: 10px; */
}
.icon-lixeira:hover,
.icon-editar:hover {
  filter: invert(0) !important;
}
.info-qtd {
  margin-top: -15px;
}
</style>
